module.exports = __webpack_public_path__ + "static/media/i3-match.cbfa4854.png";